import { format } from 'date-fns'
import { isUndefined } from 'lodash'
import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    seat: {
      min: null,
      max: null,
    },
    smoking: true,
    noSmoking: true,
    times: null,
    busy: false,
  },
  mutations: {
    set(state, { min, max, smoking, noSmoking, times = null }) {
      if (!isUndefined(min)) {
        state.seat = { min, max }
      }
      state.smoking = smoking
      state.noSmoking = noSmoking
      state.times = times
    },
    busy(state, busy = false) {
      state.busy = busy
    },
  },
  getters: {
    hasLunch: ({ times }) => !!times && times.some(({ type }) => type === 0),
    hasDinner: ({ times }) => !!times && times.some(({ type }) => type === 1),
  },
  actions: {
    async get({ commit, rootState }, { date, number, smoking, syncCourseId }) {
      commit('busy', true)

      const res = await POST(`/${rootState.reception.segment}/api/web/reception/available_time`, {
        date: format(date, 'YYYY-MM-DD'),
        number: number || undefined,
        smoking,
        syncCourseId,
      })

      if (res.status === 200) {
        const { availableTimes, ...data } = res.data
        commit('set', {
          ...data,
          times: availableTimes,
        })
      } else {
        commit('error/message', res.message, { root: true })
      }

      commit('busy', false)
      return res.status === 200
    },
  },
}
